import React from 'react';
import { motion } from 'framer-motion';
import { ProcessedImage } from '@/types';
import { config } from '@/config';

interface AttributionProps {
  image: ProcessedImage;
}

export const Attribution: React.FC<AttributionProps> = ({ image }) => {
  const isUnsplash = config.imageProvider === 'unsplash';
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4 }}
      className="fixed bottom-4 left-20 md:left-20 sm:left-4 z-10 text-white text-xs opacity-60 text-left max-w-xs"
      style={{
        textShadow: '0 1px 10px rgba(0, 0, 0, 0.8)'
      }}
    >
      <div className="mb-1">
        Photo by{' '}
        <a
          href={image.photographer_url}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80 underline"
        >
          {image.photographer}
        </a>
      </div>
      <div>
        on{' '}
        <a
          href={isUnsplash ? (image.photo_url || 'https://unsplash.com') : 'https://www.pexels.com'}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80 underline"
        >
          {isUnsplash ? 'Unsplash' : 'Pexels'}
        </a>
      </div>
    </motion.div>
  );
};